import React from 'react';
import { Link } from 'react-router-dom';
import Hero from './Hero';
import HomeFeatures from './HomeFeatures';

// Sequoia AI information
const sequoiaFeatures = [
  {
    title: 'Eco-Friendly Educational AI',
    description: 'Powered entirely by green energy and recycled hardware, minimizing environmental impact while maximizing learning.'
  },
  {
    title: 'Personalized Learning Journeys',
    description: 'Adaptive learning paths customized to each student\'s unique needs, learning style, and educational goals.'
  },
  {
    title: 'Sustainable Knowledge Access',
    description: 'Democratizing education through low-carbon computing resources that make learning accessible to more students.'
  },
  {
    title: 'Green Computing Education',
    description: 'Teaching students about sustainability while using sustainable technology, creating a virtuous educational cycle.'
  }
];

const HomePage = () => {
  return (
    <>
      <Hero />
      <HomeFeatures />

      {/* Key Services Section */}
      <section className="services-section">
        <div className="container">
          <h2 className="section-title">Our Services</h2>
          <div className="services-grid">
            {/* ESG Platform */}
            <div className="service-card esg-platform">
              <i className="fas fa-chart-line service-icon" aria-hidden="true"></i>
              <h3 className="service-title">ESG Platform</h3>
              <p className="service-description">
                Comprehensive Environmental, Social, and Governance solutions to help organizations
                measure, manage, and improve their sustainability performance.
              </p>
              <Link to="/esg-platform" className="service-cta">
                Explore Platform <i className="fas fa-arrow-right" aria-hidden="true"></i>
              </Link>
            </div>

            {/* Carbon Credits */}
            <div className="service-card carbon-credits">
              <i className="fas fa-leaf service-icon" aria-hidden="true"></i>
              <h3 className="service-title">Carbon Credits</h3>
              <p className="service-description">
                Verified carbon offset solutions and trading platform to help businesses
                achieve their carbon neutrality goals.
              </p>
              <Link to="/carbon-credits" className="service-cta">
                View Credits <i className="fas fa-arrow-right" aria-hidden="true"></i>
              </Link>
            </div>

            {/* Partner Services */}
            <div className="service-card partner-services">
              <i className="fas fa-handshake service-icon" aria-hidden="true"></i>
              <h3 className="service-title">Partner Services</h3>
              <p className="service-description">
                Collaborative solutions and partnerships to drive sustainable innovation
                and environmental impact at scale.
              </p>
              <Link to="/partner-services" className="service-cta">
                Partner With Us <i className="fas fa-arrow-right" aria-hidden="true"></i>
              </Link>
            </div>

            {/* Donations */}
            <div className="service-card donations">
              <i className="fas fa-heart service-icon" aria-hidden="true"></i>
              <h3 className="service-title">Support Our Mission</h3>
              <p className="service-description">
                Contribute to our mission of creating a sustainable future through
                technology and innovation.
              </p>
              <Link to="/donate" className="service-cta">
                Donate Now <i className="fas fa-arrow-right" aria-hidden="true"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>      {/* Sequoia AI Section */}
      <section id="faq-section" aria-label="Sequoia AI" style={{background: '#F3F4F6', padding: '2rem 0'}}>
        <div className="container">
          <h2 className="section-title">Sequoia AI</h2>
          <div className="sequoia-intro" style={{marginBottom: '2rem', maxWidth: '800px', margin: '0 auto 2rem'}}>
            <p style={{fontSize: '1.1rem', lineHeight: '1.6', color: '#374151', textAlign: 'center'}}>
              Meet Sequoia AI, our sustainable educational assistant powered 100% by green energy and 
              recycled hardware. Designed to help students learn and grow while demonstrating how 
              technology can be both powerful and environmentally responsible.
            </p>
          </div>
          
          <div className="sequoia-features" style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem'}}>
            {sequoiaFeatures.map((feature, idx) => (
              <div key={idx} className="sequoia-feature-card" style={{
                backgroundColor: '#FFFFFF', 
                borderRadius: '0.5rem', 
                padding: '1.5rem', 
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                ':hover': {
                  transform: 'translateY(-5px)',
                  boxShadow: '0 10px 15px rgba(0, 0, 0, 0.1)'
                }
              }}>
                <h3 style={{color: '#059669', fontSize: '1.25rem', marginBottom: '0.75rem', fontWeight: '600'}}>{feature.title}</h3>
                <p style={{color: '#4B5563'}}>{feature.description}</p>
              </div>
            ))}
          </div>
            <div className="sequoia-cta" style={{textAlign: 'center', marginTop: '2.5rem'}}>
            <Link to="/sequoia-ai" className="btn-primary" style={{
              display: 'inline-block',
              background: '#059669',
              color: 'white',
              padding: '0.75rem 1.5rem',
              borderRadius: '0.375rem',
              fontWeight: '600',
              textDecoration: 'none',
              transition: 'background-color 0.3s ease'
            }}>
              Explore Sequoia AI <i className="fas fa-arrow-right" style={{marginLeft: '0.5rem'}} aria-hidden="true"></i>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomePage; 